import {Component, HostListener} from '@angular/core';
import {
    ACCENT_COLORS, AccentColor, MENU_COLORS, MenuColor, TITLE_COLORS, TitleColor, ThemeChoice, ThemeService
} from './theme.service';

/** The gear icon + panel that lets a visitor change the menu colour, accent colour and page-title colour. */
@Component({
    selector: 'app-theme-switcher',
    templateUrl: './theme-switcher.component.html',
    styleUrl: './theme-switcher.component.css'
})
export class ThemeSwitcherComponent {
    open = false;
    readonly menuColors: MenuColor[] = MENU_COLORS;
    readonly accentColors: AccentColor[] = ACCENT_COLORS;
    readonly titleColors: TitleColor[] = TITLE_COLORS;

    constructor(private themes: ThemeService) {
    }

    get choice(): ThemeChoice {
        return this.themes.current;
    }

    /** Gradient menus (Ocean, Violet, Forest) are previewed as the gradient they produce. */
    swatchBackground(m: MenuColor): string {
        return m.isGradient ? `linear-gradient(135deg, ${m.dark}, ${m.light})` : m.ink;
    }

    /** The gear exists only for signed-in members. */
    get visible(): boolean {
        return this.themes.signedIn;
    }

    toggle(): void {
        this.open = this.visible && !this.open;
    }

    pickMenu(id: string): void {
        this.themes.set({menu: id});
    }

    pickAccent(id: string): void {
        this.themes.set({accent: id});
    }

    pickTitle(id: string): void {
        this.themes.set({title: id});
    }

    reset(): void {
        this.themes.reset();
    }

    @HostListener('document:keydown.escape')
    close(): void {
        this.open = false;
    }
}
